import { WSCard, WSText } from "@wingspanhq/fe-component-library";
import { RequirementType } from "@wingspanhq/wingspan-api-sdk";
import { queriesPayeeEligibilityRequirements, queriesPayers } from "@query";
import { selectorPayerDisplayName } from "../../../shared/selectors/selectorPayerDisplayName";

export const CardTaxVerificationRequirementRequester = () => {
  const queryRequirements =
    queriesPayeeEligibilityRequirements.listPayeeEligibilityRequirements.useQuery(
      {}
    );

  const hasTaxVerificationRequirement = (
    queryRequirements.data?.data ?? []
  ).some(
    requirement =>
      requirement.type === RequirementType.TAX_VERIFICATION &&
      !!requirement.engagementId
  );

  const queryPayers = queriesPayers.listPayers.useQuery(
    {},
    { enabled: hasTaxVerificationRequirement }
  );

  const payerNames = (queryPayers.data?.data ?? []).map(payer =>
    selectorPayerDisplayName(payer)
  );

  return (
    <WSCard header="Taxpayer info">
      <WSText.ParagraphSm color="gray600">
        Complete your account setup by providing your taxpayer information below
        as required by {payerNames.join(", ")}
      </WSText.ParagraphSm>
    </WSCard>
  );
};
